export enum ConnectQuestionCategory {
    COACH_APPLICATION = 'COACH_APPLICATION',
    COACHING_REQUEST = 'COACHING_REQUEST',
    MENTORING_REQUEST = 'MENTORING_REQUEST'
}